import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "https://api.ligasanguillermina.com.ar/api",
});


export const registrarJugador = (data) => api.post("/registro", data);

export const loginJugador = (data) => api.post("/login", data);

export const getJugadores = (date ) => api.get("/jugadores", {
    headers: { Authorization: `Bearer ${date}` }},)


export const getRanking = (categoria, token) =>
api.get(`/ranking/${categoria}`, {
    headers: { Authorization: `Bearer ${token}` },
});

export const crearJugador = (data, token) => api.post("/jugadores", data, {
    headers: { Authorization: `Bearer ${token}` }, });


export const actualizarJugador = (id, data, token) => api.put(`/jugadores/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },     
});
export const eliminarJugador = (id, token) => api.delete(`/jugadores/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  
});

export const getPerfil = (token) =>
    api.get("/perfil", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getJugador = (id,data, token) =>
    api.get(`/jugador/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

//crear torneo
export const crearTorneo = (data, token) => api.post("/torneos", data, {
    headers: { Authorization: `Bearer ${token}` }, });

// eliminar torneo
export const eliminarTorneo = (id, token) => api.delete(`/torneos/${id}`, {
    headers: { Authorization: `Bearer ${token}` },  
});

//obtener torneos jugador
export const getTorneosJugador = (token) => api.get("/torneos/inscritos", {
    headers: { Authorization: `Bearer ${token}` },  
});

    //obtener jugadores por dni
export const getJugadorPorDni = (dni, token) =>
api.get(`/jugadores/dni/${dni}`, {
    headers: { Authorization: `Bearer ${token}` },
});

//Datos jugador 2 dni
export const inscribirPareja = (data, token) => api.post("/inscripciones", data, {
    headers: { Authorization: `Bearer ${token}` }, });



export default api;
